import styles from '../Producer.module.scss'
import Link from 'components/link/Link'
import { routes } from 'types/routes'
import { useTranslation } from 'react-i18next'

const ProducerFooter = () => {
  // i18n
  const { t } = useTranslation(['producer', 'addresses'])

  return (
    <div className={styles['producer-footer']}>
      <small>{t(($) => $.producerFooter)}</small>
      <Link href={routes.SUPPORT_CONTACT} variant="secondary" size="small">
        {t(($) => $.overview.offtake.contact, {
          ns: 'addresses'
        })}
      </Link>
    </div>
  )
}

export default ProducerFooter
